import axios from 'axios';

const ClaimService = {
  async createClaim({ formValues, loanId }) {
    const values = {
      ...formValues,
      loan_id: loanId,
    };

    const response = await axios.post('/claim', values);

    return response.data;
  },

  async getClaim(claimId) {
    const response = await axios.get(`/claim/${claimId}`);

    return response.data;
  },

  async updateClaim({ formValues, claimId }) {
    const response = await axios.put(`/claim/${claimId}`, formValues);

    return response.data;
  },
};

export default ClaimService;
